
'use client'

import Script from "next/script"

export default function OneTrustCookie() {
  return (
    <>
      <Script
        async
        strategy="lazyOnload"
        onLoad={() => {
          'function OptanonWrapper() { }'
        }}
        src='https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js'
        type="text/javascript"
        data-domain-script="019a1187-e506-7899-a64d-f9a60c403ffc"
      />
    </>
  )
}
